module.exports = __webpack_public_path__ + "static/media/howSection5Image1.59f350c5.gif";